// Centralized PDF.js worker configuration for react-pdf
// Ensures PDFs render reliably across routes/trials.

import { pdfjs } from 'react-pdf';

// Use file copied by `npm run setup-pdf` into public/
const publicUrl = process.env.PUBLIC_URL || '';
const workerUrl = `${publicUrl}/pdf.worker.min.mjs`;

try {
  // Must be set before any <Document> mounts
  pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
  // Optional: increase verbosity for debugging PDF issues in dev
  if (process.env.NODE_ENV !== 'production') {
    // 0=errors, 1=warnings, 2=infos
    pdfjs.VerbosityLevel && (pdfjs.VerbosityLevel = 1);
  }
  // eslint-disable-next-line no-console
  console.log('[PDF] GlobalWorkerOptions.workerSrc set to', workerUrl);
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('[PDF] Failed to set workerSrc', e);
}
